import { render, staticRenderFns } from "./Home2023.vue?vue&type=template&id=f3822510&"
import script from "./Home2023.vue?vue&type=script&lang=js&"
export * from "./Home2023.vue?vue&type=script&lang=js&"
import style0 from "./Home2023.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports